export default __webpack_public_path__ + "static/media/empresa.d26c4d25.svg";